import { render, staticRenderFns } from "./FeatureTutorial.vue?vue&type=template&id=053881a8&scoped=true"
import script from "./FeatureTutorial.vue?vue&type=script&lang=js"
export * from "./FeatureTutorial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "053881a8",
  null
  
)

export default component.exports